import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  personaldevelopments: [],
  personaldevelopment: {}
}

const mutations = {  
  SET_PERSONALDEVELOPMENTS (state, payload) {
    state.personaldevelopments = payload
  },
  SET_PERSONALDEVELOPMENT (state, payload) {
    state.personaldevelopment = payload
  },
  ADD_PERSONALDEVELOPMENT (state, payload) {
    state.personaldevelopments.push(payload)
  },
  DELETE_PERSONALDEVELOPMENT (state, payload) {
    state.personaldevelopments = state.personaldevelopments.filter(element => {
      return element._id != payload
    })
  },
  CLOSE_PERSONALDEVELOPMENT (state, payload) {
    state.personaldevelopments = state.personaldevelopments.filter(element => {
      return element._id != payload._id
    })
  },
  SUBS_PERSONALDEVELOPMENT (state, payload) {
    state.personaldevelopments = state.personaldevelopments.filter((element, ind) => {
      return ind != payload 
    })
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  PersonalDevelopmentList: (context, id) => {
    return Vue.http.get(`${env.API}/api/personal-development-con`)    
      .then((response) => {        
        context.commit('SET_PERSONALDEVELOPMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getPDCByIdPlan: (context, data) => {
    const { id, user } = data
    return Vue.http.get(`${env.API}/api/personal-development-con/by-plan/${id}/${user}`)    
      .then((response) => {        
        context.commit('SET_PERSONALDEVELOPMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  createPDC: (context, data) => {
    return Vue.http.post(`${env.API}/api/personal-development-con`, data)    
      .then((response) => {        
        context.commit('SET_PERSONALDEVELOPMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getWCById: (context, id) => {
    return Vue.http.get(`${env.API}/api/personal-development-con/${id}`)    
      .then((response) => {        
        context.commit('SET_PERSONALDEVELOPMENT', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },  
  addCommentToPersonalDevelopment: (context, data) => {
    return Vue.http.post(`${env.API}/api/personal-development-con/comment`, data)    
      .then((response) => {
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getCommentsPersonalDevelopment: (context, id) => {
    return Vue.http.get(`${env.API}/api/personal-development-con/comments/${id}`)
    .then(response => {
        return response.body.message
    })
    .catch(error => {
        return context.commit('API_FAILURE', error)
    })
  },
  close: (context, id) => {
    return Vue.http.delete(`${env.API}/api/personal-development-con/${id}`)    
      .then((response) => {                
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  deletePersonalDevelopment: (context, id) => {
    return Vue.http.delete(`${env.API}/api/personal-development-con/remove/${id}`)    
      .then((response) => {      
        context.commit('DELETE_PERSONALDEVELOPMENT', response.body.commitment)       
        return response.body.success
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  closePersonalDevelopment: (context, data) => {
    const { id, accomplished } = data
    return Vue.http.put(`${env.API}/api/personal-development-con/close/${id}`, { accomplished })
      .then(response => {
        context.commit('CLOSE_PERSONALDEVELOPMENT', response.body.message)       
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getPDClistByPlanConId: (context, data) => {
    return Vue.http.post(`${env.API}/api/personal-development-con/by-plan-con`, data)    
      .then((response) => {
        context.commit('SET_PERSONALDEVELOPMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateBPersonalDevelopmentCon: (context, data) => {
    return Vue.http.put(`${env.API}/api/personal-development-con/update/batch/pd`, data)
      .then((response) => {             
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  addToPersonalDevelopmentList: (context, data) => {
    context.commit('ADD_PERSONALDEVELOPMENT', data)
    return true
  },
  subsToPersonalDevelopmentList: (context, index) => {
    context.commit('SUBS_PERSONALDEVELOPMENT', index)
    return true
  }
}

const getters = {
  getPersonalDevelopments: (state) => state.personaldevelopments,
  getPersonalDevelopment: (state) => state.personaldevelopment
}

export const personaldevelopmentcon = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/personal_development_con.js